import template from './total-area-required.jade';

export default angular
  .module('cian.addForm.buildingTotalAreaRequired', [])
  .directive('cianAfAboutBuildingTotalAreaRequired', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {},
    controllerAs: 'buildingTotalAreaRequired',
    template,
  })).name;
